import {
  LeagueRegistration,
  LeagueTable,
  LeagueTeamMember,
  LeagueTeamMemberRegistration,
  Round,
  RoundWithMatches,
  Scorer,
  Team
} from "@/models";
import { ApiResponse } from "./../models/api.model";
import axios from "./axios";

export default {
  getLeagueTeams(leagueId: number) {
    return axios.get().get<ApiResponse<Team[]>>(`/league/${leagueId}/teams`);
  },
  getLeagueTeamMembers(leagueId: number, teamId: number) {
    return axios.get().get<ApiResponse<LeagueTeamMember[]>>(`league/${leagueId}/team/${teamId}/teammember`);
  },
  getLeagueTable(leagueId: number) {
    return axios.get().get<ApiResponse<LeagueTable>>(`league/${leagueId}/table`);
  },
  getLeagueTopScorers(leagueId: number) {
    return axios.get().get<ApiResponse<Scorer[]>>(`/league/${leagueId}/topscore`);
  },
  postLeagueRegistration(leagueId: number, leagueRegistration: LeagueRegistration) {
    return axios.get().post(`/league/${leagueId}/registration`, leagueRegistration);
  },
  deleteRegistration(leagueId: number, teamId: number) {
    return axios.get().delete(`/league/${leagueId}/unregistration`, { data: { team_id: teamId } });
  },
  putTeamMembers(leagueId: number, leagueTeamMemberRegistration: LeagueTeamMemberRegistration) {
    return axios.get().put(`/league/${leagueId}/teammember`, leagueTeamMemberRegistration);
  },
  getLeagueRounds(leagueId: number) {
    return axios.get().get<ApiResponse<Round[]>>(`/league/${leagueId}/rounds`);
  },
  getLeagueRoundsWithMatches(leagueId: number) {
    return axios.get().get<ApiResponse<RoundWithMatches[]>>(`/league/${leagueId}/roundswithmatches`);
  }
};
